import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    // console.log(error)

    console.log(error,errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ textAlign: "center" }}>
          <h1 style={{ padding: "25px", color: "white", fontSize: "25px" }}>
            Something went wrong
          </h1>
          <button
            style={{
              padding: "15px",
              color: "black",
              backgroundColor: "white",
              cursor: "pointer",
            }}
            onClick={() => window.location.replace("/")}
          >
            Main page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
